import { API_CALL } from '../../configs/ActionTypes';
import { Dispatch } from 'redux';
import { enqueueSnackbarCustomMessageHandler } from '../Status';

type RefundCRCPointsParams = {
  organizationId: string;
  bookingId: string;
  pnr?: string;
  points: number;
  reason: string;
  onSuccess?: (response: any) => void;
  onError?: (message: string, raw?: any) => void;
};

const getErrorMessage = (error: any, fallback: string) => {
  return (
    error?.payload?.payload?.message ||
    error?.payload?.message ||
    error?.message ||
    fallback
  );
};

export function refundCRCPoints(params: RefundCRCPointsParams) {
  const { organizationId, bookingId, pnr, points, reason, onSuccess, onError } = params;

  return (dispatch: Dispatch) => {
    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/booking-crc-refund`,
        method: 'post',
        data: JSON.stringify({
          bookingId,
          pnr,
          points,
          reason,
        }),
        success: (response: any) => {
          if (response?.type === 'error') {
            const message = getErrorMessage(
              response,
              'Failed to refund CRC points',
            );
            enqueueSnackbarCustomMessageHandler(dispatch, message, 'error');
            onError?.(
              message,
              response,
            );
            return;
          }

          enqueueSnackbarCustomMessageHandler(
            dispatch,
            'CRC points refunded successfully.',
            'success',
          );
          onSuccess?.(response);
        },
        fail: (error: any) => {
          const message = getErrorMessage(error, 'Failed to refund CRC points');
          enqueueSnackbarCustomMessageHandler(dispatch, message, 'error');
          onError?.(message, error);
        },
      },
    });

    return null;
  };
}
